import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,

  integrations: [
    // Automatically instruments React Router - every page navigation shows
    // as a separate transaction in the Sentry performance dashboard.
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),

    // Records what the user was doing just before an error (clicks, navigations, etc.)
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],

  // Reduced from 100% — capturing every transaction on real traffic burns quota fast
  // and adds CPU overhead on every page load. 10% gives solid data without the cost.
  tracesSampleRate: 0.1,

  // 1% of normal sessions for Session Replay, always record when an error occurs
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,

  environment: import.meta.env.MODE,

  // Only send events when a DSN is configured (safe for local dev)
  enabled: !!import.meta.env.VITE_SENTRY_DSN,

  // Use keepalive fetch so the SDK doesn't need an unload listener,
  // which blocks bfcache (Back/Forward Cache) and hurts Core Web Vitals.
  transportOptions: {
    fetchOptions: { keepalive: true },
  },
});
